// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/governance/v0/payment_card_data.proto (package squareup.governance.v0, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/governance/v0/payment_card_data.proto.
 */
export const file_squareup_common_governance_v0_payment_card_data: GenFile = /*@__PURE__*/
  fileDesc("CjVzcXVhcmV1cC9jb21tb24vZ292ZXJuYW5jZS92MC9wYXltZW50X2NhcmRfZGF0YS5wcm90bxIWc3F1YXJldXAuZ292ZXJuYW5jZS52MCLZAQoPUGF5bWVudENhcmREYXRhIsUBCgxTZW1hbnRpY1R5cGUSDgoKRE9fTk9UX1VTRRAAEg4KCkNBUkRfVFJBQ0sQARIaChZDQVJEX1ZFUklGSUNBVElPTl9DT0RFEAISDAoIQ0FSRF9QSU4QAxIMCghDQVJEX1BBThAEEgwKCENBUkRfQklOEAUSEgoOQ0FSRF9MQVNUX0ZPVVIQBhIVChFDQVJEX1NFUlZJQ0VfQ09ERRAHEg8KC0NBUkRfRVhQSVJZEAgSEwoPQ0FSREhPTERFUl9OQU1FEAlCKgooY29tLnNxdWFyZXVwLnByb3Rvcy5jb21tb24uZ292ZXJuYW5jZS52MA");

/**
 * @generated from message squareup.governance.v0.PaymentCardData
 */
export type PaymentCardData = Message<"squareup.governance.v0.PaymentCardData"> & {
};

/**
 * Describes the message squareup.governance.v0.PaymentCardData.
 * Use `create(PaymentCardDataSchema)` to create a new message.
 */
export const PaymentCardDataSchema: GenMessage<PaymentCardData> = /*@__PURE__*/
  messageDesc(file_squareup_common_governance_v0_payment_card_data, 0);

/**
 * @generated from enum squareup.governance.v0.PaymentCardData.SemanticType
 */
export enum PaymentCardData_SemanticType {
  /**
   * @generated from enum value: DO_NOT_USE = 0;
   */
  DO_NOT_USE = 0,

  /**
   * The full contents of track 1 or track 2 on the magnetic stripe, or the equivalent data on the chip.
   *
   * @generated from enum value: CARD_TRACK = 1;
   */
  CARD_TRACK = 1,

  /**
   * The three-digit or four-digit verification code printed on the card.
   *
   * @generated from enum value: CARD_VERIFICATION_CODE = 2;
   */
  CARD_VERIFICATION_CODE = 2,

  /**
   * The (typically four digit) secret value known to the card holder.
   *
   * @generated from enum value: CARD_PIN = 3;
   */
  CARD_PIN = 3,

  /**
   * Primary Account Number (PAN) (more than defined by CARD_BIN and CARD_LAST_FOUR).
   *
   * @generated from enum value: CARD_PAN = 4;
   */
  CARD_PAN = 4,

  /**
   * Issuer Identification Number (IIN), aka Bank Identification Number (BIN). The first six or eight digits of the PAN (depends on the institution issuing the card), that identifies the financial institution that issued the card.
   *
   * @generated from enum value: CARD_BIN = 5;
   */
  CARD_BIN = 5,

  /**
   * Last four digits (or fewer) of a Primary Account Number.
   *
   * @generated from enum value: CARD_LAST_FOUR = 6;
   */
  CARD_LAST_FOUR = 6,

  /**
   * Three-digit or four-digit value in the magnetic-stripe that follows the expiration date of the payment card on the track data. It is used for various things such as defining service attributes, differentiating between international and national interchange, or identifying usage restrictions.
   *
   * @generated from enum value: CARD_SERVICE_CODE = 7;
   */
  CARD_SERVICE_CODE = 7,

  /**
   * The expiration date associated with a payment card.
   *
   * @generated from enum value: CARD_EXPIRY = 8;
   */
  CARD_EXPIRY = 8,

  /**
   * The name of a cardholder. May be an individual, business, or other given name written on the payment card.
   *
   * @generated from enum value: CARDHOLDER_NAME = 9;
   */
  CARDHOLDER_NAME = 9,
}

/**
 * Describes the enum squareup.governance.v0.PaymentCardData.SemanticType.
 */
export const PaymentCardData_SemanticTypeSchema: GenEnum<PaymentCardData_SemanticType> = /*@__PURE__*/
  enumDesc(file_squareup_common_governance_v0_payment_card_data, 0, 0);

